import { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { ShieldCheck, CheckCircle, XCircle } from "@phosphor-icons/react";

export default function Quality() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/quality-reviews").then(({ data }) => setItems(data)); }, []);
  return (
    <div className="space-y-5" data-testid="quality-page">
      <div>
        <div className="label-eyebrow">Quality Systems</div>
        <h1 className="font-display text-[28px] font-bold tracking-tight mt-1">Quality Reviews</h1>
        <div className="text-[12px] text-[var(--span-text-2)] mt-1">Evidence QA · report gate · case closure checklist</div>
      </div>
      <div className="card-flat">
        <table className="span-table">
          <thead><tr><th></th><th>Case</th><th>Type</th><th className="text-right">Score</th><th>Result</th><th>Reviewer</th><th>Notes</th><th>Date</th></tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={8} className="py-6 text-center text-[12px] text-[var(--span-text-2)]">No reviews yet.</td></tr>}
            {items.map(q => (
              <tr key={q.review_id}>
                <td><ShieldCheck size={16} className={q.passed ? "text-[var(--span-success)]" : "text-[var(--span-danger)]"} weight="bold" /></td>
                <td className="font-mono text-[11px]">{q.case_id.slice(0, 12)}…</td>
                <td><span className="badge">{q.type}</span></td>
                <td className="text-right tnum font-mono font-semibold">{q.score}/100</td>
                <td>{q.passed ? <span className="badge badge-success"><CheckCircle size={11}/>&nbsp;Pass</span> : <span className="badge badge-danger"><XCircle size={11}/>&nbsp;Fail</span>}</td>
                <td>{q.reviewer}</td>
                <td className="text-[12px] text-[var(--span-text-2)] max-w-[280px] truncate">{q.notes}</td>
                <td className="text-[var(--span-text-2)]">{fmtDate(q.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
